// Foto delle visite: compresse nel browser prima del caricamento (lato lungo 1600 px, JPEG 82%).
// Se la foto non si riesce a leggere, o compressa pesa di più, parte quella originale.

export const MAX_FOTO_VISITA = 5;
const LATO_MASSIMO = 1600;
const QUALITA = 0.82;

export const comprimiFoto = (file) => new Promise((risolvi) => {
  if (!file?.type?.startsWith('image/') || typeof document === 'undefined') { risolvi(file); return; }
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const scala = Math.min(1, LATO_MASSIMO / Math.max(img.naturalWidth, img.naturalHeight));
    const tela = document.createElement('canvas');
    tela.width = Math.round(img.naturalWidth * scala);
    tela.height = Math.round(img.naturalHeight * scala);
    const ctx = tela.getContext('2d');
    if (!ctx) { URL.revokeObjectURL(url); risolvi(file); return; }
    ctx.drawImage(img, 0, 0, tela.width, tela.height);
    tela.toBlob((blob) => {
      URL.revokeObjectURL(url);
      if (!blob || blob.size >= file.size) { risolvi(file); return; }
      const nome = (file.name || 'foto').replace(/\.[^.]+$/, '') || 'foto';
      risolvi(new File([blob], `${nome}.jpg`, { type: 'image/jpeg' }));
    }, 'image/jpeg', QUALITA);
  };
  img.onerror = () => { URL.revokeObjectURL(url); risolvi(file); };
  img.src = url;
});
